var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#605F64",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 23.5026L14.7667 31.2293C14.5586 31.4745 14.3019 31.6738 14.0128 31.8147C13.7237 31.9555 13.4085 32.0349 13.0872 32.0477C12.7659 32.0604 12.4454 32.0064 12.146 31.8889C11.8467 31.7715 11.5749 31.5932 11.348 31.3653C11.1202 31.1375 10.942 30.865 10.8247 30.565C10.7074 30.2649 10.6535 29.9438 10.6664 29.6219C10.6793 29.3 10.7587 28.9843 10.8997 28.6946C11.0406 28.4049 11.24 28.1475 11.4853 27.9386L19.1933 21.3586",
    stroke: "#605F64",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 21.4226L25.3974 28.04M21.2694 10.668L14.6667 17.2866M34.6667 23.5453L37.3334 21.3586M34.6667 27.9186L37.3334 29.376M22.6694 37.332H36.0001M24.3027 37.332C25.0374 36.0146 25.5867 33.496 28.1894 33.3546C28.9627 33.312 29.7494 33.312 30.5227 33.3546C33.1241 33.496 33.6761 36.0146 34.4121 37.332M20.4441 11.496L15.4934 16.4586C15.4934 16.4586 17.9694 19.768 20.4454 22.2493C22.9227 24.7306 26.2241 27.2133 26.2241 27.2133L31.1761 22.2493C31.1761 22.2493 28.7001 18.9413 26.2241 16.4586C23.7481 13.9786 20.4441 11.496 20.4441 11.496Z",
    stroke: "#605F64",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.c89c3cfab0946c3a60310fa95453ee2c.svg";
export { ForwardRef as ReactComponent };